import { SellerLeadIndicationSummaryQuery } from 'graphql/types'

type TTransformProps = {
  title?: string | null
  count?: number | null
} | null

export const getSellerLeadIndicationsSummary = (
  data?: SellerLeadIndicationSummaryQuery,
) => {
  if (!data || data.sellerLeadSummary?.length === 0) return null

  const transformProps = (item?: TTransformProps) => ({
    label: item?.title || '',
    value: item?.count || 0,
  })

  const transformItems = (subtotals?: Array<TTransformProps | null> | null) => {
    if (!subtotals) return []

    return subtotals.map((item) => transformProps(item))
  }

  const findByStatus = (status: string) =>
    data?.sellerLeadSummary?.find((item) => item?.leadStatus === status)

  const response = []

  const summaryPublisheds = findByStatus('Publicado')
  if (summaryPublisheds)
    response.push({
      status: summaryPublisheds?.leadStatus as string,
      content: {
        hero: transformProps(summaryPublisheds),
        items: transformItems(summaryPublisheds?.subtotals),
        href: '/perfil/minhas-indicacoes/publicadas',
      },
    })

  const summaryAnalysis = findByStatus('Em Análise')
  if (summaryAnalysis)
    response.push({
      status: summaryAnalysis?.leadStatus as string,
      content: {
        hero: transformProps(summaryAnalysis),
        items: transformItems(summaryAnalysis?.subtotals),
        content:
          summaryAnalysis.count !== 0
            ? 'Nossos analistas estão validando se as indicações estão dentro dos padrões previstos. Nesse momento aguarde nosso time entrar em contato.'
            : undefined,
        href: '/perfil/minhas-indicacoes/em-analise',
      },
    })

  const summaryDisqualified = findByStatus('Desqualificado')
  if (summaryDisqualified)
    response.push({
      status: summaryDisqualified?.leadStatus as string,
      content: {
        hero: transformProps(summaryDisqualified),
        items: transformItems(summaryDisqualified?.subtotals),
        href: '/perfil/minhas-indicacoes/desqualificadas',
      },
    })

  return response
}
